module.exports = __webpack_public_path__ + "b745d0bef837afa7f7c6765c059d6210.svg";